import React from 'react';
import PropTypes from 'prop-types';
import { ResourceRequestStatus } from '~/types';
import { useMeContext } from '~/modules/me';
import ResourceRequestChartBanner from '~/modules/resourcing/common/components/ResourceRequestChartBanner/ResourceRequestChartBanner';
import { ResourceRequestAcceptAllButton } from './ResourceRequestAcceptAllButton';
import {
  hasEditProjectAndTeamPermission,
  hasResourceAllocationEditPermission
} from './util';

export const ResourceRequestAcceptAllChartBanner = ({
  resourceRequests,
  allocationChartRef,
  project
}) => {
  const me = useMeContext();

  const hasPermission = hasResourceAllocationEditPermission(me.permissions);
  const submittedResourceRequests = hasPermission
    ? resourceRequests.filter(
        resourceRequest =>
          resourceRequest.requestStatus === ResourceRequestStatus.Submitted &&
          resourceRequest.resourceMatches?.length &&
          hasEditProjectAndTeamPermission(resourceRequest, project)
      )
    : [];

  return submittedResourceRequests.length ? (
    <ResourceRequestChartBanner messageId="resourceRequestChartBanner.acceptRequests">
      <ResourceRequestAcceptAllButton
        resourceRequests={submittedResourceRequests}
        allocationChartRef={allocationChartRef}
      />
    </ResourceRequestChartBanner>
  ) : null;
};

ResourceRequestAcceptAllChartBanner.propTypes = {
  resourceRequests: PropTypes.array.isRequired,
  allocationChartRef: PropTypes.object,
  project: PropTypes.object
};
export default ResourceRequestAcceptAllChartBanner;
